(function ($) {
	const EOS_API_URL = "https://forms.eos.com/submit/eos-contact-us/";

	const $body = $("body");
	let scrollPosition = 0;

	let formInteractionTracked = false;  // flag for request_form_start

	initSelect();
	initPhoneInputFilter();
	initValidate();
	initAnalyticsTracking();
	hidePopup();

	function initAnalyticsTracking() {
		if (typeof dataLayer === 'undefined') {
			console.warn('dataLayer is not defined');
			return;
		}

		trackFirstFormInteraction();
	}

	function trackFirstFormInteraction() {
		if (formInteractionTracked) return;

		const sendStartEvent = () => {
			if (formInteractionTracked) return;
			formInteractionTracked = true;
			console.log('✅ GA: request_form_start');
			dataLayer.push({ 'event': 'EOSCOM', 'eventCategory': 'RiskMonitoring', 'eventAction': 'request_form_start', 'eventLabel': 'contacts_section', 'eventContent': '', 'eventPosition': '', 'eventContext': '' });
		};

		$('#contact-form input, #contact-form textarea, #contact-form select').each(function() {
			const $field = $(this);
			if ($field.hasClass('select2-hidden-accessible')) return;
			
			$field.one('focus', sendStartEvent);
		});

		$('#area, #industry, #country_operation, #country-code').on('select2:open', function() {
			sendStartEvent();
		});
	}

	function overflowBody() {
		scrollPosition = window.pageYOffset;
		$body.css({
			overflow: "hidden",
			position: "fixed",
			top: `-${scrollPosition}px`,
			width: "100%",
		});
	}

	function overflowBodyRemove() {
		const $html = $("html");
		const originalScrollBehavior = $html.css("scroll-behavior");

		$html.css("scroll-behavior", "auto");
		$body.css({ overflow: "", position: "", top: "", width: "" });

		window.scrollTo({ top: scrollPosition, behavior: "instant" });
		$html.css("scroll-behavior", originalScrollBehavior || "");
	}

	function hidePopup() {
		$(".popup-close").on("click", function () {
			$(".popup-overlay").fadeOut();
			overflowBodyRemove();
		});
	}

	function showPopupSuccess() {
		$(".popup-success").fadeIn();
		overflowBody();

		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({'event':'EOSCOM', 'eventCategory':'RiskMonitoring', 'eventAction':'request_form_success', 'eventLabel':'contacts_section', 'eventContent':'', 'eventPosition':'', 'eventContext':''});
		}
	}

	function showPopupFailed() {
		$(".popup-failed").fadeIn();
		overflowBody();

		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({'event':'EOSCOM', 'eventCategory':'RiskMonitoring', 'eventAction':'request_form_error', 'eventLabel':'contacts_section', 'eventContent':'', 'eventPosition':'', 'eventContext':''});
		}
	}

	function initSelect() {

		const select2Placeholders = {
			en: { area: "Select area", industry: "Select type", country: "Select country", phone: "Phone number" },
			es: { area: "Seleccionar área", industry: "Seleccionar tipo", country: "Seleccionar país", phone: "Número de teléfono" },
			pt: { area: "Selecionar área", industry: "Selecionar tipo", country: "Selecionar país", phone: "Número de telefone" }
		};

		function getCurrentLanguage() {
			const htmlLang = document.documentElement.lang || 'en';
			if (htmlLang === 'es' || htmlLang === 'pt') return htmlLang;
			return 'en';
		}	

		const currentLang = getCurrentLanguage();
		const placeholders = select2Placeholders[currentLang] || select2Placeholders.en;

		const $selectArea = $("#area");
		if ($selectArea.length) {
			$selectArea
				.select2({
					placeholder: placeholders.area,
					minimumResultsForSearch: Infinity,
					width: "100%",
				})
				.on("change", function () {
					$(this).closest(".form-field").removeClass("error").find(".error").remove();
				})
				.trigger("change.select2");
		}

		const $selectIndustry = $("#industry");
		if ($selectArea.length) {
			$selectIndustry
				.select2({
					placeholder: placeholders.industry,
					minimumResultsForSearch: Infinity,
					width: "100%",
				})
				.on("change", function () {
					$(this).closest(".form-field").removeClass("error").find(".error").remove();
				})
				.trigger("change.select2");
		}

		const $selectCountry = $("#country_operation");
		if ($selectCountry.length) {
			$selectCountry
				.select2({
					placeholder: placeholders.country,
					width: "100%",
					templateResult: function (data) {
						if (!data.element) return data.text;
						var $result = $("<span>" + data.text + "</span>");
						if (data.element.className) {
							$result.addClass(data.element.className);
						}
						return $result;
					},
				})
				.on("change", function () {
					$(this).closest(".form-field").removeClass("error").find(".error").remove();
				})
				.trigger("change.select2");
		}

		const $selectCountryCode = $("#country-code");
		const $phoneInput = $("#phone-number");

		$selectCountryCode
			.select2({
				placeholder: placeholders.phone,
				minimumResultsForSearch: Infinity,
				width: "100%",
				templateSelection: (state) => (state.id ? $(`<span>${state.id}</span>`) : state.text),
				templateResult: (state) => state.text,
				escapeMarkup: (markup) => markup,
			})
			.val("")
			.trigger("change.select2");

		$selectCountryCode.on("change", function () {
			const selectedCode = $(this).val();
			const $phoneInput = $("#phone-number");

			setTimeout(() => {
				if (selectedCode && selectedCode !== "Other") {
					const currentPhone = $phoneInput.val().trim();

					if (!currentPhone || currentPhone === selectedCode) {
						$phoneInput
							.val(selectedCode + " ")
							.focus()
							.addClass("focus");
					}
				} else if (selectedCode === "Other") {
					if (!$phoneInput.val().startsWith("+")) {
						$phoneInput.val("+").focus().addClass("focus");
					}
				}
			}, 50);
			$(this).closest(".form-field").removeClass("error").find(".error").remove();
		});

		$phoneInput.on("input blur", function (e) {
			if ($(this).val().trim() === "") {
				$(this).removeClass("focus");
				$selectCountryCode.val("").trigger("change.select2");
			} else if (e.type === "input") {
				$(this).addClass("focus");
			}
		});

		if (typeof window.initAutoCountryAndArea === "function") {
			window.initAutoCountryAndArea();
		}
	}

	function initPhoneInputFilter() {
		const $phoneInput = $("#phone-number");
		const $selectCountryCode = $("#country-code");

		if (!$phoneInput.length) return;

		$phoneInput.val("");

		$phoneInput.on("input", function () {
			let cleanValue = this.value.replace(/[^0-9\s\-()+]/g, "");

			if (cleanValue.indexOf("+") > 0) {
				cleanValue = cleanValue[0] + cleanValue.slice(1).replace(/\+/g, "");
			}

			this.value = cleanValue;
			const trimmed = cleanValue.trim();

			if (!trimmed || trimmed === "+") {
				if (trimmed === "") $selectCountryCode.val("").trigger("change.select2");
			}
		});

		$phoneInput.on("keydown", function (e) {
			const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End", "Control", "Meta"];
			if (/[\d\s\-()+]/.test(e.key) || allowedKeys.includes(e.key)) return;
			e.preventDefault();
		});
	}

	function insertSiteUrlIntoForm(form) {
		const $urlInput = $(form).find("[name=Request_Form_URL]");
		if (!$urlInput.length) return;

		const currentUrl = window.location.href;
		const cleanUrl = currentUrl.length > 250 ? currentUrl.substring(0, 247) + "..." : currentUrl;
		$urlInput.val(cleanUrl);
	}

	function getCurrentLanguage() {
		const htmlLang = document.documentElement.lang || "en";
		if (htmlLang === "es" || htmlLang === "pt") return htmlLang;
		return "en";
	}

	function initValidate() {
		const $form = $("#contact-form");
		if (!$form.length) return false;

		const validationMessages = {
			en: {
				required: "Please fill out this field.",
				email: "Please enter a valid email address.",
				tel: "Please enter a valid telephone number.",
			},
			es: {
				required: "Por favor, complete este campo.",
				email: "Por favor, introduzca una dirección de correo electrónico válida.",
				tel: "Por favor, introduzca un número de teléfono válido.",
			},
			pt: {
				required: "Por favor, preencha este campo.",
				email: "Por favor, insira um endereço de e-mail válido.",
				tel: "Por favor, insira um número de telefone válido.",
			}
		};

		const currentLang = getCurrentLanguage();
		const messages = validationMessages[currentLang] || validationMessages.en;

		var validationConfig;
		if ($form.hasClass("form-free-access")) {
			validationConfig = {
				rules: {
					First_Name: "required",
					Last_Name: "required",
					Email: { required: true, email: true },
					country_operation: "required",
					Area_to_monitor: "required",
					Phone: {
						required: true,
						intlPhone: true,
					},
				},
				messages: {
					Phone: {
						minlength: messages.tel,
						intlPhone: messages.tel,
					},
				},
				highlight: (element) => $(element).closest(".form-field").addClass("error"),
				unhighlight: (element) => $(element).closest(".form-field").removeClass("error"),
				submitHandler: function (form) {
					if (typeof dataLayer !== "undefined") {
						dataLayer.push({ event: "EOSCOM", eventCategory: "RiskMonitoring", eventAction: "request_form_submit", eventLabel: "contacts_section", eventContent: "", eventPosition: "", eventContext: "" });
					}

					insertSiteUrlIntoForm(form);

					const firstName = $(form).find("#first-name").val() || "";
					const lastName = $(form).find("#last-name").val() || "";
					$(form).find("#crm-request-name").val(`${firstName} ${lastName} - Apply for early access`);

					sendFormData(form);
				},
			};
		} else {
			validationConfig = {
				rules: {
					First_Name: "required",
					Last_Name: "required",
					Email: { required: true, email: true },
					Company_Name: "required",
					Area_to_monitor: "required",
					industry: "required",
					country_operation: "required",
					Message: "required",
					Phone: {
						required: true,
						intlPhone: true,
					},
				},
				messages: {
					Phone: {
						minlength: messages.tel,
						intlPhone: messages.tel,
					},
				},
				highlight: (element) => $(element).closest(".form-field").addClass("error"),
				unhighlight: (element) => $(element).closest(".form-field").removeClass("error"),
				submitHandler: function (form) {
					if (typeof dataLayer !== "undefined") {
						dataLayer.push({ event: "EOSCOM", eventCategory: "RiskMonitoring", eventAction: "request_form_submit", eventLabel: "contacts_section", eventContent: "", eventPosition: "", eventContext: "" });
					}

					insertSiteUrlIntoForm(form);

					const firstName = $(form).find("#first-name").val() || "";
					const lastName = $(form).find("#last-name").val() || "";
					$(form).find("#crm-request-name").val(`${firstName} ${lastName} - Apply for early access`);

					sendFormData(form);
				},
			};
		}

		$.validator.methods.tel = () => true;

		$.validator.addMethod(
			"intlPhone",
			function (value, element) {
				const countrySelectVal = $form.find("[name='country-code']").val() || "";

				if (countrySelectVal === "Other") {
					return true;
				}

				const { iso, isOther } = parseCountryValue(countrySelectVal);
				const result = validatePhoneNumber(value, iso, isOther, countrySelectVal);

				if (result.isValid && result.formatted && document.activeElement !== element) {
					element.value = result.formatted;
				}

				return this.optional(element) || result.isValid;
			},
			messages.tel,
		);

		$.extend($.validator.messages, {
			required: messages.required,
			email: messages.email,
		});

		$form.validate(validationConfig);

		$("[name='country-code']").on("change", function () {
			if ($("#phone-number").val().trim() !== "") {
				$form.validate().element("#phone-number");
			}
		});
	}

	const sendFormData = async (form) => {
		const formData = new FormData(form);
		const rawData = Object.fromEntries(formData.entries());

		const fullPhone = rawData["Phone"] || "";
		const countryCode = rawData["country-code"] || "";

		const hasPlus = fullPhone.startsWith("+") ? "+" : "";
		const digitsOnly = fullPhone.replace(/[^0-9]/g, "");
		const formattedPayloadPhone = hasPlus + digitsOnly;

		const jsonPayload = {
			first_name: rawData["First_Name"] || "",
			last_name: rawData["Last_Name"] || "",
			email: rawData["Email"] || "",
			phone: formattedPayloadPhone,
			company: rawData["Company_Name"] || "",
			area: rawData["Area_to_monitor"] || "",
			message: rawData["Message"] || "",
			product_group: rawData["Product_Group"] || "",
			product: rawData["Product_CRM"] || "",
			subject: rawData["Subject"] || "",
			country_code: countryCode === "Other" ? "" : countryCode,
			name: rawData["Name"] || "",
			ip: rawData["user-ip"] || "",
			country: rawData["country_operation"] || "",
			ga_client_id: rawData["ga_client_id"] || "",
			form_url: rawData["Request_Form_URL"] || "",
			industry: rawData["industry"] || "",
		};

		// console.log("[API Send] Sending JSON to EOS:", jsonPayload);

		try {
			const response = await fetch(EOS_API_URL, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				credentials: "include",
				body: JSON.stringify(jsonPayload),
			});

			if (response.ok || response.status === 0) {
				// console.log("[API Success] Data successfully received by the EOS server!");
				showPopupSuccess();
				formReset(form);
			} else {
				showPopupFailed();
				console.error(`The server returned the following status: ${response.status}`);
			}
		} catch (error) {
			console.error("[API Error] Error sending the form to EOS:", error);
			showPopupFailed();
		}
	};

	function formReset(form) {
		form.reset();
		$("select").val("").trigger("change.select2");
		const $phoneInput = $("#phone-number");
		$phoneInput.removeClass("focus");
	}
})(jQuery);
